// src/debugLogger.js
import axios from 'axios';

// separate axios instance WITHOUT interceptors
const debugAxios = axios.create({
    baseURL: process.env.VUE_APP_API
});

export function logDebugEvent(event) {
    // Optional: enable only in dev or when flag is true
    // if (process.env.NODE_ENV !== 'development') return;
    if (process.env.VUE_APP_ENABLE_DEBUG_LOG !== 'true') {
        return;
    }
    console.log('logDebugEvent called with', event); // add this so you can see it
    // fire-and-forget, don't break UI
    debugAxios.post('/auth/debug-log', {
        ...event,
        timestamp: event.timestamp || new Date().toISOString()
    }).catch(err => {
        // don't spam console, but up to you
        console.error('debug log failed', err);
    });
}
